import PublicationList from '../components/publication/PublicationList.tsx';

type Props = {};

export default function IndexPage({}: Props) {
    return <PublicationList />;
}
